<h3 mat-dialog-title >
    <b>Boleta Previdência</b> 
 </h3>
 
 <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="data.cliente_id == null">
     <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
         <mat-label>Cliente</mat-label>
         <input 
             matInput 
             placeholder="Digite o nome ou conta de um cliente" 
             aria-label="Cliente"  
             [formControl]="cliente" 
             name="cliente" 
             required
             [matAutocomplete]="auto">
         <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
             <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                 <span> {{cliente.nome}}</span> |
                 <small>Conta: {{cliente.numero_xp }}</small>
             </mat-option>
         </mat-autocomplete>
         <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
         <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
     </mat-form-field>
 </div>

 <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
        <mat-label>Característica</mat-label>
        <input 
            matInput 
            placeholder="Digite o nome ou CNPJ da Previdência" 
            aria-label="Característica"  
            [formControl]="caracteristica" 
            name="caracteristica" 
            required
            [matAutocomplete]="auto">
        
        <mat-autocomplete 
            #auto="matAutocomplete" 
            [displayWith]="displayFnCaracteristica"  
            (optionSelected)='getCaracteristicaNome($event.option.value)'
        >
            <mat-option 
                *ngFor="let caracteristica of filteredOptionsCaracteristica | async" 
                [value]="caracteristica"
            >
                <span> {{caracteristica.nome}} </span> |
                <small>CNPJ: {{caracteristica.cnpj }}</small>
            </mat-option>
        </mat-autocomplete>
        <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinnerCaracteristica">account_circle</mat-icon>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerCaracteristica"></mat-spinner>
    </mat-form-field>
</div>

 <div fxLayout="row" fxLayoutAlign="space-between">
    <mat-form-field style="width: 100%" floatLabel="always" fxFlex="100" appearance="outline" >
        <mat-label>Quantidade</mat-label>
        <input 
            matInput 
            placeholder="Quantidade" 
            [formControl]="qtd"
            maxlength="10"> 
    </mat-form-field>
</div>
 
 <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
     <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="100">
         <mat-label>Ação Comercial</mat-label>
         <mat-select             
             [(value)]="model.acao_comercial_id"
             [formControl]="acao_comercial_id">
             <mat-option value="">SELECIONE</mat-option>
             <mat-option *ngFor="let acaoComercial of listAcaoComercial"
                 [value]="acaoComercial.id">{{acaoComercial.nome}}</mat-option>
         </mat-select>
         <mat-spinner diameter="20" *ngIf="loadingSpinnerAcaoComercial"></mat-spinner> 
     </mat-form-field>
 </div>
 
 <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
     <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
         <mat-label>Status</mat-label>
         <mat-select 
             placeholder="Status"
             [(value)]="model.status_id" 
             [formControl]="status_id"
             name="status_id"
             required
             *ngIf="data" >
                 <mat-option *ngFor="let status of listStatus" [value]="status.id">{{status.nome}}</mat-option>
         </mat-select>
         <mat-spinner diameter="20" *ngIf="loadingSpinnerStatus"></mat-spinner>
     </mat-form-field>
 </div>

 <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Observação</mat-label>
        <textarea 
            matInput 
            placeholder="Observação" 
            [formControl]="observacao" 
            name="observacao"
            [rows]="3">
        </textarea>                                        
    </mat-form-field>
 </div>
 
 <div mat-dialog-content>
     <div fxLayout="row wrap">
         <div fxFlex.gt-sm="100%">
             <p style="text-align: center; color: #030a31;">
                 <b>Qual o valor</b> que deseja <b>{{texto}}</b> ?
             </p>
             <mat-form-field style="width: 100%">                
                 <input 
                     matInput 
                     placeholder="Valor" 
                     [formControl]="valor" 
                     required
                     style="font-size: 30px;"
                     currencyMask 
                     [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                     maxlength="255">
                 <mat-error *ngIf="valor.invalid">{{getErrorValorMessage()}}</mat-error>
             </mat-form-field>
         </div>
     </div>
 </div>
 
 <div mat-dialog-actions style="text-align: center; margin-top: 20px;">
     <button 
         mat-button 
         tabindex="2" 
         (click)="onNoClick()">
         Cancelar
     </button>
     <button 
         mat-button 
         [disabled]="isInvalidForm()" 
         (click)="salvar()" 
         tabindex="-1">
         Confirmar
     </button>
 </div>